import React from 'react';
import MenuBook from '@material-ui/icons/MenuBook';
import Search from '@material-ui/icons/Search';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import SEO from './components/SEO';
import { getPerspectiveBySlug } from './data/perspectives';
import './PageHome.css';

const featuredPerspectives = [
    getPerspectiveBySlug('what-does-paul-mean-by-works-of-the-law'),
    getPerspectiveBySlug('what-does-paul-mean-by-justification'),
    getPerspectiveBySlug('what-is-sanctification'),
].filter(Boolean);

const Home = ({ onBrowseBooks }) => {
    const title = 'ai-BIBLE | Read the Bible with Context, Cross References and Devotionals';
    const description = 'Explore Bible passages, people, places, book outlines, cross references, and devotionals on ai-BIBLE.';

    document.title = title;

    const scrollToBooks = () => {
        const filterTabs = document.getElementById('testament-filter-tabs');
        if (filterTabs) filterTabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (onBrowseBooks) onBrowseBooks();
    };

    return (
        <>
            <SEO canonical="https://www.ai-bible.com/" title={title} description={description} />
            <section className="home-hero" aria-labelledby="home-hero-title">
                <div className="home-hero-copy">
                    <p className="home-hero-eyebrow"><MenuBook aria-hidden="true" /> Explore the Bible</p>
                    <h1 id="home-hero-title">Read clearly. Explore deeply<span>.</span></h1>
                    <p className="home-hero-description">
                        ai-BIBLE is a clear, accessible way to read the Bible and explore
                        passages, people, places, and cross references with ease. It makes
                        biblical study easier today, with future work focused on interpretation
                        and application.
                    </p>
                    <div className="home-hero-actions">
                        <button className="home-action home-action-primary" type="button" onClick={scrollToBooks}>
                            <MenuBook aria-hidden="true" /> Browse books
                        </button>
                        <a className="home-action home-action-secondary" href="/web-mcp-support">
                            <span aria-hidden="true">✦</span> Web MCP Support
                        </a>
                    </div>
                    <div className="home-perspectives-links" aria-label="Featured perspectives">
                        <p className="home-perspectives-label">Explore perspectives</p>
                        <div className="home-perspectives-row">
                            <a className="home-perspectives-hub" href="/perspectives">Browse all topics</a>
                            {featuredPerspectives.map((topic) => (
                                <a key={topic.slug} className="home-perspectives-chip" href={`/perspectives/${topic.slug}`}>
                                    {topic.shortTitle}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
                <figure className="home-hero-art">
                    <img src="/ChristLandscape.jpg" alt="Artwork depicting Jesus" />
                </figure>
            </section>
            <section className="home-feature-grid" aria-label="Explore ai-BIBLE">
                <a className="home-feature-card home-feature-button" href="/read/Gen.1/">
                    <span className="home-feature-icon"><MenuBook aria-hidden="true" /></span>
                    <div>
                        <h2>Dive in deep</h2>
                        <p>Read closely and explore Scripture&apos;s connections.</p>
                    </div>
                </a>
                <a className="home-feature-card home-feature-button" href="/search">
                    <span className="home-feature-icon"><Search aria-hidden="true" /></span>
                    <div>
                        <h2>Easy to explore</h2>
                        <p>Browse books, search, and discover passages with ease.</p>
                    </div>
                </a>
                <a className="home-feature-card home-feature-button" href="/plans">
                    <span className="home-feature-icon"><FavoriteBorder aria-hidden="true" /></span>
                    <div>
                        <h2>Made for every journey</h2>
                        <p>Tools and plans to help you grow in faith, every day.</p>
                    </div>
                </a>
            </section>
        </>
    );
};

export default Home;
